// ABOUTME: Compact pill showing % change from first to last value across the visible period.
// ABOUTME: Used in the pivot table left-panel rows to surface trend direction at a glance.
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

export const RhDeltaPill = ({ values }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    if (!values || values.length < 3) return null;
    const first = Number(values[0]);
    const last = Number(values[values.length - 2]);
    if (!isFinite(first) || !isFinite(last) || first === 0) return null;

    const pct = ((last - first) / first) * 100;
    const isFlat = Math.abs(pct) < 1;
    const isUp = pct > 0;
    const arrow = isFlat ? '→' : (isUp ? '↑' : '↓');

    const palette = isFlat
        ? { bg: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100], text: colors.grey[400] }
        : isUp
            ? { bg: colors.green[100], text: colors.green[400] }
            : { bg: colors.red[100], text: colors.red[400] };

    return (
        <Box
            title="Change across visible period (first → last)"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                background: palette.bg,
                color: palette.text,
                borderRadius:3,
                padding: '2px 12px',
                fontSize: 12,
                fontWeight: 700,
                height:24,
                flexShrink: 0,
                userSelect: 'none',
            }}
        >
            {arrow} {Math.abs(pct).toFixed(0)}%
        </Box>
    );
};
